// Game-module shim (unify Phase 3): resolves to the active game's DraftsPageContent.
// Conditional require so only the active game's module tree is evaluated.
import game from '../games';
const impl = game.id === 'mlbb'
  ? require('../games/mlbb/components/DraftsPageContent')
  : require('../games/dota/components/DraftsPageContent');
export default impl.default;
